/**
 * @file_purpose  page for showing App cost calculator category 
 * @author Sucheta Singha
 * @Date_Created 20-08-2024
 * @Date_Modified 20-08-2024
 */
import React, { useState, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
    CLabel,
    CFormGroup,
    CButton,
    CInputRadio
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import GeneralService from "src/apis/GeneralService";
import Constants from "src/Utility/Constants";
import RouteURL from "src/apis/ApiURL";
import MasterData from "src/Utility/MasterData";


export default function AppCostCategory() {
    const RAT_WEBSITE_ORIGIN="https://ems.redappletech.com";
    const history = useHistory();
    const [loadingData, setLoadingData] = useState(true);
    const [isButtonDisable, setIsButtonDisable] = useState(true);
    const [costCategories, setCostCategories] = useState([]);
    const [costRequiredServices, setCostRequiredServices] = useState(MasterData.costCalculatorRequiredService);
    const [state, setState] = useState({
        service_id: '',
        category_id: '',
    })

    useEffect(() => {
        window.scrollTo(0, 0)
        localStorage.removeItem('fixed-cost-calculator');
        localStorage.removeItem('budgetValues');
        localStorage.removeItem('team_structure');
        localStorage.removeItem('radio_extension');
        localStorage.removeItem('offerValues');
        localStorage.removeItem('update-category-existing')
    }, [])

    useEffect(() => {

        /**
      * @author Sucheta Singha
      * @Date_Created 20-08-2024
      * @Date_Modified 20-08-2024
      * @function async
      * @functionName loadCostCategories
      * @functionPurpose this function gets the list of categories.
      *
      * @functionParam {}
      * 
      * @functionSuccess Success status and message.
      *
      * @functionError {Boolean} error is there.
      * @functionError {String} message  Description message.
      */

        async function loadCostCategories() {
            GeneralService.apiGetCallRequestWithoutToken(RouteURL.getCostFieldCategory)
                .then((res) => {
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        setCostCategories(res.data);
                        setLoadingData(false)
                    }
                    else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                }).catch(error => {
                    console.log(error)
                })

        }

        if (loadingData) {
            loadCostCategories()
        }

    }, [loadingData]);

    const handleChangeRadio = (e) => {
        // console.log(e)
        const { id, value } = e.target
        setState(prevState => ({
            ...prevState,
            [id]: value
        }))
        // checkedValidation()
    }

    const nextSubmitClick = (e) => {
        e.preventDefault();
        // [
        //     { id: 1, name: "Hire Your Own Team",is_checked:0 },
        //     { id: 2, name: "Get A Fixed Cost",is_checked:0  },
        //     { id: 3, name: "Update on Existing Development",is_checked:0  },
        //   ]
        if (state.service_id == 2) {
            history.push({
                pathname: `/fixed-cost-calculator/${state.category_id}/${state.service_id}`,
            });
        } else if (state.service_id == 1) {
            history.push({
                pathname: `/hire-your-own-team/${state.category_id}/${state.service_id}`,
            });
        } else if (state.service_id == 3) {
            history.push({
                pathname: `/update-category-existing/${state.category_id}/${state.service_id}`,
            });
        }
    }


    useEffect(() => {
        if (state.category_id && state.service_id) {
            setIsButtonDisable(false)
        } else {
            setIsButtonDisable(true)
        }
    }, [state])

    const checkedValidation = () => {
        if (!state.category_id && !state.service_id) {
            setIsButtonDisable(true)
        } else {
            setIsButtonDisable(false)
        }
    }


    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });

    const sendHeight = () => {
        // Send the height of the iframe content to the parent page

        var data = {
            source: 'ems.redappletech.com/calculator',
            value: document.body.scrollHeight
        };
        // window.parent.postMessage(document.body.scrollHeight, '*');
        // console.log("sending message to the parent",data);
        setTimeout(() => {
            //window.postMessage({ type: "CUSTOM_EVENT", payload: "Hello!" }, "*");
            window.parent.postMessage(data, RAT_WEBSITE_ORIGIN);
            console.log("message to the parent",data);
          }, 1000);
        //window.parent.postMessage(data, '*');
        //console.log("message to the parent",data);
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });


    return (
        <body style={{ backgroundColor: "#fff" }}>

            <div className="appoinment_hed">
                <h4>
                    Lets Calculate The Ballpark Cost Of Your Project
                </h4>
                <div className='main_require'>
                    <div className="container main_cont">
                        <div className='row'>
                            <div className='col-sm-12'>
                                <h6 className='requiretxt'>Requirement</h6>
                                <div className='row'>
                                    <div className='col-md-2'></div>
                                    {costCategories?.map((item, index) => (
                                        <div className="col-md-4">

                                            <div className='require_box'>
                                                <label class={item.field_category_id == state.category_id ? "con1 label_drk" : "con1"}><span>{item.field_type}</span>
                                                    <input type="radio" name="category_id"
                                                        onChange={handleChangeRadio}
                                                        checked={item.field_category_id == state.category_id}
                                                        id="category_id" value={item.field_category_id} />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>


                                            {/* <div className='require_box'>
                                                <input type='radio' className="form-check-input" name="category_id"
                                                    onChange={handleChangeRadio}
                                                    checked={item.field_category_id == state.category_id}
                                                    id="category_id" value={item.field_category_id} />
                                                <CLabel key={item.field_category_id}>
                                                    {item.field_type}
                                                </CLabel>
                                            </div> */}

                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="container main_cont">
                        <div className='row'>
                            <div className='col-sm-12'>
                                <h6 className='requiretxt'>Required Services</h6>
                                <div className="row">



                                    {costRequiredServices?.map((item, index) => (
                                        <div className="col-md-4">

                                            <div className='require_box'>
                                                <label class={item.id == state.service_id ? "con1 label_drk" : "con1"}><span>{item.name}</span>
                                                    <input type="radio" name="service_id"
                                                        onChange={handleChangeRadio}
                                                        checked={item.id == state.service_id} id="service_id" value={item.id} />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>

                                            {/* <div className='custom-radio'>

                                                <input type='radio' className="form-check-input" name="service_id"
                                                    onChange={handleChangeRadio}
                                                    checked={item.id == state.service_id}
                                                    id="service_id" value={item.id} />

                                                <CLabel className="custom-checkmark" key={item.id}>

                                                </CLabel>
                                                <p></p>

                                            </div> */}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="booking_btns_sec">
                        <div className="atten_sec1 col-12 text-center">
                            <CButton className={isButtonDisable ? "app_next" : "app_next next_red"} disabled={isButtonDisable ? true : false}
                                style={{ background: isButtonDisable ? '#DFDFDF' : '#E84C3D' }}
                                onClick={nextSubmitClick}>
                                Next
                            </CButton>
                        </div>
                    </div>
                </div>

            </div>

        </body >

    )
}



